import { Country } from '../model/interfaces/country';
import { Injectable } from '@angular/core';
import { countries } from '../resources/countries';

@Injectable()
export class LocationService
{
    public getCountries(): Country[]
    {
        return countries;
    }
}
